<template>
  <div
    id="user-menu"
    class="the-navbar__user-meta flex items-center"
    v-if="activeUserInfo"
  >
    <div class="text-right leading-tight sm:block">
      <p class="font-semibold">{{ activeUserInfo.name }}</p>
      <!-- <small>Available</small> -->
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3 user-icon">
        <img
          v-if="activeUserInfo.photoURL"
          key="onlineImg"
          :src="activeUserInfo.photoURL"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        <span
          v-else
          class="rounded-full shadow-md cursor-pointer block user-letter"
        >
          {{ activeUserInfo.name | getLetter }}
        </span>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Perfil</span>
          </li> -->

          <!-- <vs-divider class="m-1" /> -->

          <li class="flex py-2 px-2 cursor-pointer amplify-sign-out">
            <amplify-sign-out
              v-bind:signOutConfig="signOutConfig"
            ></amplify-sign-out>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";

export default {
  data() {
    return {
      signedIn: false,
      signOutConfig: {
        signOutButton: "Sair",
      },
    };
  },
  async beforeCreate() {
    try {
      await this.$Amplify.Auth.currentAuthenticatedUser();
      this.signedIn = true;
    } catch (err) {
      this.signedIn = false;
    }
    AmplifyEventBus.$on("authState", (info) => {
      this.signedIn = info === "signedIn";
    });
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  filters: {
    getLetter(item) {
      if (!item) return;
      return String(item && item[0]).toUpperCase();
    },
  },
};
</script>

<style lang="scss">
.amplify-sign-out {
  div[data-test] {
    background: red;
    div {
      margin: 0;
    }
  }
}
#user-menu {
  .user-icon {
    .user-letter {
      background: #ccc;
      display: block;
      padding: 9px 5px;
      width: 40px;
      height: 40px;
      font-size: 20px;
      border-radius: 100%;
    }
  }
}
</style>
